import React, { useEffect, useRef, useState } from "react";
import { BARS }   from "../lib/data";
import { useReveal } from "../lib/hooks";


const SECTION_CSS = `
  .silk-road-section {
    padding: 40px 48px;
    position: relative;
    overflow: hidden;
  }
  .silk-road-section::before {
    content: '';
    position: absolute;
    top: -200px; right: -200px;
    width: 600px; height: 600px;
    pointer-events: none;
  }
  body.dark .silk-road-section::before {
    background: radial-gradient(circle, rgba(118,0,255,0.06) 0%, transparent 70%);
  }
  body.light .silk-road-section::before {
    background: radial-gradient(circle, rgba(118,0,255,0.04) 0%, transparent 70%);
  }
  .sr-inner {
    max-width: 1100px;
    margin: 0 auto;
  }
  .sr-label {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 4px;
    text-transform: uppercase;
    color: #E40186;
    margin-bottom: 32px;
  }
  .sr-title {
    font-family: 'Syne', sans-serif;
    font-size: clamp(30px, 4vw, 50px);
    font-weight: 800;
    line-height: 1.08;
    margin-bottom: 20px;
    max-width: 800px;
    color: rgb(var(--navy));
    letter-spacing: -1.5px;
  }
  body.dark .sr-title { color: #fff; }
  body.light .sr-title { color: #111; }
  .sr-title-accent {
    background: linear-gradient(135deg, #E40186, #7600FF);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .sr-subtitle {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 17px;
    line-height: 1.7;
    max-width: 620px;
    font-weight: 300;
    margin-bottom: 64px;
    color: rgb(var(--navy));
  }
  body.dark .sr-subtitle { color: rgba(255,255,255,0.5); }
  body.light .sr-subtitle { color: rgba(0,0,0,0.55); }
  .sr-grid {
    display: grid;
    grid-template-columns: 1.2fr 0.8fr;
    gap: 56px;
    align-items: stretch;
  }
  .sr-chart {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .sr-bar-item {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .sr-bar-label {
    width: 140px;
    text-align: right;
    flex-shrink: 0;
  }
  .sr-bar-name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.3;
    color: rgb(var(--navy));
  }
  body.dark .sr-bar-name { color: rgba(255,255,255,0.75); }
  body.light .sr-bar-name { color: rgba(0,0,0,0.7); }
  .sr-bar-track {
    flex: 1;
    height: 40px;
    border-radius: 3px;
    overflow: hidden;
  }
  body.dark .sr-bar-track { background: rgba(255,255,255,0.03); }
  body.light .sr-bar-track { background: rgba(0,0,0,0.06); }
  .sr-bar-fill {
    height: 100%;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 14px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    width: 0;
    transition: width 1.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .sr-bar-fill.silk-road {
    background: linear-gradient(90deg, #7600FF, #E40186);
    color: #fff;
  }
.sr-bar-fill.universal {
    background: linear-gradient(90deg, rgb(var(--box_sh)), rgb(var(--helper_txt_color)));
    color: #fff;
  }
.sr-bar-fill.sony {
    background: linear-gradient(90deg, rgb(var(--box_sh)), rgb(var(--helper_txt_color)));
    color: #fff;
  }
.sr-bar-fill.warner {
    background: linear-gradient(90deg, rgb(var(--box_sh)), rgb(var(--helper_txt_color)));
    color: #fff;
  }

  body.dark .sr-bar-fill.universal { background: rgba(255,255,255,0.10); color: rgba(255,255,255,0.6); }
  body.dark .sr-bar-fill.sony { background: rgba(255,255,255,0.07); color: rgba(255,255,255,0.5); }
  body.dark .sr-bar-fill.warner { background: rgba(255,255,255,0.04); color: rgba(255,255,255,0.4); }
  body.light .sr-bar-fill.universal { background: rgba(0,0,0,0.14); color: rgba(0,0,0,0.6); }
  body.light .sr-bar-fill.sony { background: rgba(0,0,0,0.10); color: rgba(0,0,0,0.55); }
  body.light .sr-bar-fill.warner { background: rgba(0,0,0,0.07); color: rgba(0,0,0,0.5); }
  .sr-card-wrap {
    padding: 2px;
    border-radius: 12px;
    display: flex;
    background: linear-gradient(135deg, rgba(118,0,255,0.3), rgba(228,1,134,0.3));
  }
  body.dark .sr-card-wrap { background: linear-gradient(135deg, rgba(118,0,255,0.3), rgba(228,1,134,0.3)); }
  body.light .sr-card-wrap { background: linear-gradient(135deg, rgba(118,0,255,0.2), rgba(228,1,134,0.2)); }
  .sr-card-inner {
    border-radius: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 12px;
    flex: 1;
  }
  body.dark .sr-card-inner { background: #111118; }
  body.light .sr-card-inner { background: #fff; }
  .sr-badge {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #E40186;
    padding-bottom: 12px;
    border-bottom: 1px solid rgb(var(--sub_canvas));
  }
  body.dark .sr-badge { border-bottom: 1px solid rgba(255,255,255,0.06); }
  body.light .sr-badge { border-bottom: 1px solid rgba(0,0,0,0.08); }
  .sr-source {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 11px;
    padding-top: 8px;
    color: rgb(var(--helper_txt_color));
    
    border-top: 1px solid rgb(var(--sub_canvas));
  }
  body.dark .sr-source { color: rgba(255,255,255,0.3); border-top: 1px solid rgba(255,255,255,0.06); }
  body.light .sr-source { color: rgba(0,0,0,0.4); border-top: 1px solid rgba(0,0,0,0.08); }
  .sr-source a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 2px;
    transition: color 0.3s;
  }
  body.dark .sr-source a:hover { color: rgba(255,255,255,0.5); }
  body.light .sr-source a:hover { color: rgba(0,0,0,0.7); }
  .sr-copy {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    line-height: 1.7;
    font-weight: 400;
    padding-top: 12px;
    color: rgb(var(--navy));
    border-top: 1px solid rgb(var(--sub_canvas));
  }
  body.dark .sr-copy { color: rgba(255,255,255,0.65); border-top: 1px solid rgba(255,255,255,0.06); }
  body.light .sr-copy { color: rgba(0,0,0,0.6); border-top: 1px solid rgba(0,0,0,0.08); }
  .sr-reveal {
    opacity: 0;
    transform: translateY(32px);
    transition: opacity 0.8s ease, transform 0.8s ease;
  }
  .sr-reveal.visible {
    opacity: 1;
    transform: translateY(0);
  }
  @media (max-width: 900px) {
    .silk-road-section { padding: 80px 24px; }
    .sr-grid { grid-template-columns: 1fr; gap: 48px; }
    .sr-bar-label { width: 100px; }
  }
`;

function BarChart({ animate }) {
  return (
    <div className="sr-chart">
      {BARS.map((bar) => (
        <div className="sr-bar-item" key={bar.cls}>
          <div className="sr-bar-label">
            <span className="sr-bar-name">{bar.label}</span>
          </div>
          <div className="sr-bar-track">
            <div
              className={`sr-bar-fill ${bar.cls}`}
              style={{ width: animate ? `${bar.pct}%` : "0%" }}
            >
              {bar.value}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function PPLCard() {
  return (
    <div className="sr-card-wrap">
      <div className="sr-card-inner">
        <div className="sr-badge">PPL India — verified data</div>
        <div className="sr-source">
          Source:{" "}
          <a
            href="https://www.pplindia.org/songs/"
            target="_blank"
            rel="noopener noreferrer"
          >
            PPL India — pplindia.org/songs
          </a>
          , as on 15 August 2026.
        </div>
        <div className="sr-copy">
          Every track is legally traceable from composer to your licence. No
          anonymous uploads. No unverified rights. No surprise copyright claim on
          your content — ever.
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// MAIN EXPORT
// ─────────────────────────────────────────────

export default function SilkRoadSection() {
  const [ref, visible] = useReveal(0.1);

  useEffect(() => {
    const id = "silk-road-section-css";
    if (!document.getElementById(id)) {
      const style = document.createElement("style");
      style.id = id;
      style.textContent = SECTION_CSS;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <section className="silk-road-section" style={{background :"rgb(var(--canvas))"}}>
      <div className="sr-inner" ref={ref}>
        <div className={`sr-reveal ${visible ? "visible" : ""}`}>
          <div className="sr-label">Powered by Silk Road Communications</div>

          <h2 className="sr-title">
            SyncMama is backed by India's{" "}
            <span className="sr-title-accent">largest music publisher</span>
          </h2>

          <p className="sr-subtitle">
            2.9 million copyrights from the world's leading independent
            publishers — federated on a single multi-territory platform.
          </p>
        </div>

        <div
          className={`sr-grid sr-reveal ${visible ? "visible" : ""}`}
          style={{ transitionDelay: "0.2s" }}
        >
          <BarChart animate={visible} />
          <PPLCard />
        </div>
      </div>
    </section>
  );
}
